export function isHttpError(error) {
    if (!(error instanceof Error)) {
        return false;
    }
    return error.isWixHttpError === true;
}
export function extractHttpErrorDetails(error) {
    return {
        requestId: error.requestId,
        config: extractHttpErrorConfig(error),
        response: extractHttpErrorResponse(error),
    };
}
function extractHttpErrorConfig(error) {
    var _a;
    const { url, method, params, data } = (_a = error.config) !== null && _a !== void 0 ? _a : {};
    const config = Object.assign(Object.assign({ url,
        method }, (params && { params: JSON.stringify(params) })), (data && { data: JSON.stringify(data) }));
    return config;
}
function extractHttpErrorResponse(error) {
    var _a;
    const { status, statusText, data } = (_a = error.response) !== null && _a !== void 0 ? _a : {};
    const response = Object.assign({ status,
        statusText }, (data && { data: JSON.stringify(data) }));
    return response;
}
export function getSerializableHttpError(error) {
    var _a, _b;
    const { status, statusText, data } = (_a = error.response) !== null && _a !== void 0 ? _a : {};
    const { url, method, params, data: configData } = (_b = error.config) !== null && _b !== void 0 ? _b : {};
    const response = {
        status,
        statusText,
        data,
    };
    const config = {
        url,
        method,
        params,
        data: configData,
    };
    return {
        code: error.code,
        config,
        response,
        isWixHttpError: error.isWixHttpError,
        requestId: error.requestId,
    };
}
//# sourceMappingURL=http-error.js.map